export default "../css/d7efd3e2e1ccae370992065a478fa4d7.ttf";